var _path, _circle, _path2, _circle2, _path3, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFieldIconTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3179 7.69016C10.3179 6.46007 11.3151 5.46289 12.5451 5.46289H15.2724C16.5025 5.46289 17.4997 6.46007 17.4997 7.69016C17.4997 8.01651 17.2351 8.28107 16.9088 8.28107H10.9088C10.5824 8.28107 10.3179 8.01651 10.3179 7.69016Z",
    stroke: "#4D4558"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9093,
    cy: 2.20901,
    r: 1.70901,
    stroke: "#4D4558"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.69016C0.5 6.46007 1.49718 5.46289 2.72727 5.46289H5.45454C6.68463 5.46289 7.68182 6.46007 7.68182 7.69016C7.68182 8.01651 7.41726 8.28107 7.09091 8.28107H1.09091C0.764559 8.28107 0.5 8.01651 0.5 7.69016Z",
    stroke: "#4D4558"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.09146,
    cy: 2.20901,
    r: 1.70901,
    stroke: "#4D4558"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40869 9.15403C5.40869 7.92394 6.40588 6.92676 7.63596 6.92676H10.3632C11.5933 6.92676 12.5905 7.92394 12.5905 9.15403C12.5905 9.48038 12.3259 9.74494 11.9996 9.74494H5.9996C5.67325 9.74494 5.40869 9.48038 5.40869 9.15403Z",
    fill: "#F0F2F9",
    stroke: "#4D4558"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00076,
    cy: 3.65237,
    r: 1.70901,
    stroke: "#4D4558"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldIconTeam);
export default __webpack_public_path__ + "static/media/fieldIconTeam.073cfa58e79bd43cf25e6de5045e902e.svg";
export { ForwardRef as ReactComponent };